import Api, { Action } from '../utils/apiUtil';
import * as types from '../constants/actionTypes';
import config from '../config';

const getSupportedLanguages = () => {
  return dispatch => {
    dispatch(Action(types.LOAD_LANGUAGES));

    return Api.jsonService(
      `${config.serviceApi}MDP/api/supportedLanguages/getSupportedLanguages`,
      'get',
      null,
    )
      .then(result => {
        if (result.Success === 'true') {
          const {
            Payload: { data: payloadData },
          } = result;

          if (payloadData?.ErrorCode) {
            dispatch(Action(types.LOAD_LANGUAGES_FAIL, payloadData));
          } else {
            dispatch(Action(types.LOAD_LANGUAGES_SUCCESS, payloadData));
          }
        } else {
          dispatch(Action(types.LOAD_LANGUAGES_FAIL, result.Error));
        }
      })
      .catch(err => {
        dispatch(Action(types.LOAD_LANGUAGES_FAIL, err.Error || err));
      });
  };
};

export default getSupportedLanguages;
